import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Modal from "modal-react-native-web";
import * as ImagePicker from "expo-image-picker";
import { useRecoilState } from "recoil";
import { tokenState, userState } from "../reducer/recoil";
import axios from "axios";
import Dropdown from "../component/dropdown";
import { FontAwesome, Entypo, Ionicons } from "@expo/vector-icons";
import { CalendarPicker, RangePicker } from "react-minimal-datetime-range";
const { width, height } = Dimensions.get("window");
import * as DocumentPicker from "expo-document-picker";
import { useIsFocused } from "@react-navigation/native";
import {
  createAthlete,
  createFinalAthlete,
  editAthlete,
  getCompetitionComponents,
  createOffice,
  editOfficial,
  deleteFinalAth,
} from "../action/authAction";
import moment from "moment";

export default function finalEntryAdd({ navigation, route }) {
  const [value, setValue] = useState({});
  const [state, setState] = useState({
    first_name: "",
    middle_name: null,
    last_name: null,
    gender: route.params.gender,
    image: null,
    birth_date: new Date(),
    passport: "",
  });
  const [token, setToken] = useRecoilState(tokenState);
  const [profile, setProfile] = useRecoilState(userState);
  const [errored, seterrored] = useState(false);

  const [BestValue, setBestValue] = useState([
    {
      event: route.params.event,
      personal_best_stat: "00:00:00",
      personal_best_date: moment().format("YYYY-MM-DD"),
      personal_best_venue: "",
      season_best_stat: "00:00:00",
      season_best_date: moment().format("YYYY-MM-DD"),
      season_best_venue: "",
    },
  ]);
  const [data, setData] = useState(null);
  const [disable, setDisable] = useState(false);
  const [image, setImage] = useState(null);
  const [image1, setImage1] = useState(null);

  const [showCalendarBirth, setShowCalendarBirth] = useState(false);
  const [showCalendarPersonal, setShowCalendarPersonal] = useState(null);
  const [showCalendarSeason, setShowCalendarSeason] = useState(null);
  const TODAY = new Date();
  const [validate, setValidate] = useState("");
  const [BirthYear, setBirthYear] = useState(TODAY.getFullYear());
  const [BirthMonth, setBirthMonth] = useState(
    (TODAY.getMonth() + 1).toString().length == 1
      ? "0" + (TODAY.getMonth() + 1)
      : TODAY.getMonth() + 1
  );
  const [BirthDate, setBirthDate] = useState(
    TODAY.getDate().toString().length == 1
      ? "0" + TODAY.getDate()
      : TODAY.getDate()
  );
  const [PersonalYear, setPersonalYear] = useState(TODAY.getFullYear());
  const [PersonalMonth, setPersonalMonth] = useState(
    (TODAY.getMonth() + 1).toString().length == 1
      ? "0" + (TODAY.getMonth() + 1)
      : TODAY.getMonth() + 1
  );
  const [PersonalDate, setPersonalDate] = useState(
    TODAY.getDate().toString().length == 1
      ? "0" + TODAY.getDate()
      : TODAY.getDate()
  );
  const [SeasonYear, setSeasonYear] = useState(TODAY.getFullYear());
  const [SeasonMonth, setSeasonMonth] = useState(
    (TODAY.getMonth() + 1).toString().length == 1
      ? "0" + (TODAY.getMonth() + 1)
      : TODAY.getMonth() + 1
  );
  const [SeasonDate, setSeasonDate] = useState(
    TODAY.getDate().toString().length == 1
      ? "0" + TODAY.getDate()
      : TODAY.getDate()
  );
  const focus = useIsFocused();

  const uploadImage = async (singleFile) => {
    if (singleFile != null) {
      const fileToUpload = singleFile;
      const data = new FormData();
      data.append("image_athlete", fileToUpload);
      // Please change file upload URL
      let res = await fetch(
        "https://dev-api-aaa.rawipas.me/api/athletes/upload_image",
        {
          method: "post",
          body: data,
          headers: {
            "Content-Type": "multipart/form-data; ",
            Authorization: "Bearer " + token.token,
          },
        }
      );
      let responseJson = await res.json();
      if (responseJson.status == 1) {
        console.log("Upload Successful");
      }
    } else {
      console.log("Please Select File first");
    }
  };

  function hour(val) {
    let hour = limit(val.substring(0, 2), "23");
    return hour;
  }

  function minute(val) {
    let minute = limit(val.substring(0, 2), "59");
    return minute;
  }

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      quality: 0.1,
    });
    if (!result.cancelled) {
      setImage(result.uri);
    }
  };

  useEffect(() => {
    callCoutry();
  }, [focus]);

  // const result = Object.keys(route.params.approbation_details.events_male).map(
  //   (key) => {
  //     return { label: key, value: key };
  //   }
  // );

  // const result2 = Object.keys(
  //   route.params.approbation_details.events_female
  // ).map((key) => {
  //   return { label: key, value: key };
  // });

  async function callCoutry() {
    const Country = require("../json/country.json");
    setData(
      Country.map((item) => {
        return { label: item.country, value: item.country };
      })
    );
  }

  async function condition2() {
    if (
      route.params.approbation_details.athlete_male_numbers == 0 &&
      value !== "Official" &&
      state.gender == "Male"
    ) {
      setValidate("[Athletes] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else if (
      route.params.approbation_details.athlete_female_numbers == 0 &&
      value !== "Official" &&
      state.gender == "Female"
    ) {
      setValidate("[Athletes] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else if (
      route.params.approbation_details.official_male_numbers == 0 &&
      route?.params?.event == "Official" &&
      state.gender == "Male"
    ) {
      setValidate("[Official] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else if (
      route.params.approbation_details.official_female_numbers == 0 &&
      route?.params?.event == "Official" &&
      state.gender == "Female"
    ) {
      setValidate("[Official] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else {
      deleteFinalAth({
        state: route.params.id,
        token: token.token,
      });

      let Athelebody = {
        ...state,
        association_id: profile.profile.Association.association_id,
        country_id: profile.profile.Association.country_id,
        first_name: state.first_name,
        last_name: state.last_name,
      };

      const resp = await createOffice({
        body: Athelebody,
        token: token.token,
      });

      if (resp) {
        let finalbody = {
          official_id: resp.result.official_id,
          athlete_id: null,
          approbation_id: route.params.approbation_id,
          competition_id: parseInt(route.params.competition_id),
          event_name: ["100 meters", "150 meters"],
          best_record: [],
          final_entry_athletes: route.params.final_entry_athletes.filter(
            (item) => item != false
          ),
          final_entry_officials: route.params.final_entry_officials.filter(
            (item) => item != false
          ),
        };

        const response = await createFinalAthlete({
          body: finalbody,
          token: token.token,
        });
        if (response) {
          let Athelebody = {
            official_id: resp.result.official_id,
            association_id: profile.profile.Association.association_id,
            country_id: profile.profile.Association.country_id,
            first_name: state.first_name,
            middle_name: state.middle_name,
            last_name: state.last_name,
            gender: state.gender,
            image: image,
            new_image: image,
            birth_date: state.birth_date,
            passport: state.passport,
            best_record: BestValue.map((val) => {
              return {
                ...val,
                season_best_stat:
                  (val.season_best_stat.split(":")[0].length > 1
                    ? val.season_best_stat.split(":")[0]
                    : "0" + val.season_best_stat.split(":")[0]) +
                  ":" +
                  (val.season_best_stat.split(":")[1].length > 1
                    ? val.season_best_stat.split(":")[1]
                    : "0" + val.season_best_stat.split(":")[1]) +
                  ":" +
                  (val.season_best_stat.split(":")[2].length > 1
                    ? val.season_best_stat.split(":")[2]
                    : "0" + val.season_best_stat.split(":")[2]),
                personal_best_stat:
                  (val.personal_best_stat.split(":")[0].length > 1
                    ? val.personal_best_stat.split(":")[0]
                    : "0" + val.personal_best_stat.split(":")[0]) +
                  ":" +
                  (val.personal_best_stat.split(":")[1].length > 1
                    ? val.personal_best_stat.split(":")[1]
                    : "0" + val.personal_best_stat.split(":")[1]) +
                  ":" +
                  (val.personal_best_stat.split(":")[2].length > 1
                    ? val.personal_best_stat.split(":")[2]
                    : "0" + val.personal_best_stat.split(":")[2]),
              };
            }),
          };
          const resp2 = await editOfficial({
            body: Athelebody,
            token: token.token,
          });

          // console.log(resp2);
          if (resp2) {
            setDisable(false);
            navigation.goBack();
          }
        } else {
          setValidate("[Officials] limit reached. (Limit: x)");
          onModalShow();
          setDisable(false);
        }
      }
    }
  }

  async function condition() {
    if (
      route.params.approbation_details.athlete_male_numbers == 0 &&
      value !== "Official" &&
      state.gender == "Male"
    ) {
      setValidate("[Athletes] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else if (
      route.params.approbation_details.athlete_female_numbers == 0 &&
      value !== "Official" &&
      state.gender == "Female"
    ) {
      setValidate("[Athletes] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else if (
      route.params.approbation_details.official_male_numbers == 0 &&
      route?.params?.event == "Official" &&
      state.gender == "Female"
    ) {
      setValidate("[Athletes] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else if (
      route.params.approbation_details.official_female_numbers == 0 &&
      route?.params?.event == "Official" &&
      state.gender == "Female"
    ) {
      setValidate("[Athletes] limit reached. (Limit: x)");
      onModalShow();
      setDisable(false);
      return;
    } else {
      deleteFinalAth({
        state: route.params.id,
        token: token.token,
      });

      let Athelebody = {
        ...state,
        association_id: profile.profile.Association.association_id,
        country_id: profile.profile.Association.country_id,
      };

      const resp = await createAthlete({
        body: Athelebody,
        token: token.token,
      });

      if (resp) {
        let finalbody = {
          athlete_id: resp.createAthlete.athlete_id,
          official_id: null,
          approbation_id: route.params.approbation_id,
          competition_id: parseInt(route.params.competition_id),
          event_name: ["100 meters", "150 meters"],
          best_record:
            route?.params?.event == "Official"
              ? []
              : BestValue.map((val) => {
                  return {
                    ...val,
                    season_best_stat:
                      (val.season_best_stat.split(":")[0].length > 1
                        ? val.season_best_stat.split(":")[0]
                        : "0" + val.season_best_stat.split(":")[0]) +
                      ":" +
                      (val.season_best_stat.split(":")[1].length > 1
                        ? val.season_best_stat.split(":")[1]
                        : "0" + val.season_best_stat.split(":")[1]) +
                      ":" +
                      (val.season_best_stat.split(":")[2].length > 1
                        ? val.season_best_stat.split(":")[2]
                        : "0" + val.season_best_stat.split(":")[2]),
                    personal_best_stat:
                      (val.personal_best_stat.split(":")[0].length > 1
                        ? val.personal_best_stat.split(":")[0]
                        : "0" + val.personal_best_stat.split(":")[0]) +
                      ":" +
                      (val.personal_best_stat.split(":")[1].length > 1
                        ? val.personal_best_stat.split(":")[1]
                        : "0" + val.personal_best_stat.split(":")[1]) +
                      ":" +
                      (val.personal_best_stat.split(":")[2].length > 1
                        ? val.personal_best_stat.split(":")[2]
                        : "0" + val.personal_best_stat.split(":")[2]),
                  };
                }),
          final_entry_athletes: route.params.final_entry_athletes,
          final_entry_officials: route.params.final_entry_officials,
        };

        const response = await createFinalAthlete({
          body: finalbody,
          token: token.token,
        });

        console.log("response", response);

        if (response) {
          let Athelebody = {
            athlete_id: resp.createAthlete.athlete_id,
            association_id: profile.profile.Association.association_id,
            country_id: profile.profile.Association.association_id,
            first_name: state.first_name,
            middle_name: state.middle_name,
            last_name: state.last_name,
            gender: state.gender,
            image: image,
            new_image: image,
            birth_date: state.birth_date,
            passport: state.passport,
          };

          const resp2 = await editAthlete({
            body: Athelebody,
            token: token.token,
          });

          console.log("resp2", resp2);

          setDisable(false);
          navigation.goBack();
        } else {
          setValidate("[Athletes] limit reached. (Limit: x)");
          onModalShow();
          setDisable(false);
        }
      }
    }
  }

  async function Submit() {
    try {
      if (route.params.Athlete == undefined) {
        await condition();
      } else {
        let Athelebody = {
          id: route.params.id,
          athlete_id: route.params.athlete_id,
          association_id: profile.profile.Association.association_id,
          country_id: route.params.Athlete.association_id,
          first_name: state.first_name,
          middle_name: state.middle_name,
          last_name: state.last_name,
          gender: state.gender,
          image: image,
          new_image: image != image1 ? image : null,
          birth_date: state.birth_date,
          passport: state.passport,
          best_record:
            route?.params?.event == "Official"
              ? []
              : BestValue.map((val) => {
                  return {
                    ...val,
                    season_best_stat:
                      (val.season_best_stat.split(":")[0].length > 1
                        ? val.season_best_stat.split(":")[0]
                        : "0" + val.season_best_stat.split(":")[0]) +
                      ":" +
                      (val.season_best_stat.split(":")[1].length > 1
                        ? val.season_best_stat.split(":")[1]
                        : "0" + val.season_best_stat.split(":")[1]) +
                      ":" +
                      (val.season_best_stat.split(":")[2].length > 1
                        ? val.season_best_stat.split(":")[2]
                        : "0" + val.season_best_stat.split(":")[2]),
                    personal_best_stat:
                      (val.personal_best_stat.split(":")[0].length > 1
                        ? val.personal_best_stat.split(":")[0]
                        : "0" + val.personal_best_stat.split(":")[0]) +
                      ":" +
                      (val.personal_best_stat.split(":")[1].length > 1
                        ? val.personal_best_stat.split(":")[1]
                        : "0" + val.personal_best_stat.split(":")[1]) +
                      ":" +
                      (val.personal_best_stat.split(":")[2].length > 1
                        ? val.personal_best_stat.split(":")[2]
                        : "0" + val.personal_best_stat.split(":")[2]),
                  };
                }),
        };
        if (value != route.params.type) {
          newCondition();
        } else {
          console.log("Athelebody >> ", BestValue);
          const resp1 = await editAthlete({
            body: Athelebody,
            token: token.token,
          });

          console.log(resp1);
          if (resp1) {
            setDisable(false);
            navigation.goBack();
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function limit(val, max) {
    if (val.length === 1 && val[0] > max[0]) {
      val = "0" + val;
    }
    if (val.length === 2) {
      if (Number(val) === 0) {
        val = "00";
      } else if (val > max) {
        val = max;
      }
    }
    return val;
  }

  async function SubmitOfficial() {
    try {
      // console.log("SubmitOfficial", route.params);
      // console.log("SubmitOfficial", profile);
      if (route.params.Athlete == undefined) {
        condition2();
      } else {
        let Athelebody = {
          official_id: route.params.official_id,
          association_id: route.params.Athlete.association_id,
          country_id: route.params.Athlete.association_id,
          first_name: state.first_name,
          middle_name: state.middle_name,
          last_name: state.last_name,
          gender: state.gender,
          image: image,
          birth_date: state.birth_date,
          passport: state.passport,
          best_record:
            route?.params?.event == "Official"
              ? []
              : BestValue.map((val) => {
                  return {
                    ...val,
                    season_best_stat:
                      (val.season_best_stat.split(":")[0].length > 1
                        ? val.season_best_stat.split(":")[0]
                        : "0" + val.season_best_stat.split(":")[0]) +
                      ":" +
                      (val.season_best_stat.split(":")[1].length > 1
                        ? val.season_best_stat.split(":")[1]
                        : "0" + val.season_best_stat.split(":")[1]) +
                      ":" +
                      (val.season_best_stat.split(":")[2].length > 1
                        ? val.season_best_stat.split(":")[2]
                        : "0" + val.season_best_stat.split(":")[2]),
                    personal_best_stat:
                      (val.personal_best_stat.split(":")[0].length > 1
                        ? val.personal_best_stat.split(":")[0]
                        : "0" + val.personal_best_stat.split(":")[0]) +
                      ":" +
                      (val.personal_best_stat.split(":")[1].length > 1
                        ? val.personal_best_stat.split(":")[1]
                        : "0" + val.personal_best_stat.split(":")[1]) +
                      ":" +
                      (val.personal_best_stat.split(":")[2].length > 1
                        ? val.personal_best_stat.split(":")[2]
                        : "0" + val.personal_best_stat.split(":")[2]),
                  };
                }),
        };
        if (value != route.params.type) {
          newCondition();
        } else {
          console.log("editOfficial", Athelebody);
          const resp1 = await editOfficial({
            body: Athelebody,
            token: token.token,
          });

          console.log(resp1);
          if (resp1) {
            setDisable(false);
            navigation.goBack();
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  console.log("type >>> ", route.params.type);

  useEffect(() => {
    if (route.params != undefined) {
      if (typeof route.params.Athlete == "string") {
        // route.params.Athlete = JSON.parse(route.params.Athlete);
      } else {
        try {
          console.log("เข้า >>>>>>");
          setImage(route.params.Athlete.image_url);
          setImage1(route.params.Athlete.image_url);

          setState(
            route?.params?.event == "Official"
              ? route.params.Officials
              : route.params.Athlete
          );
          setBirthYear(
            route?.params?.event == "Official"
              ? route.params.Officials.birth_date.split("T")[0].split("-")[0]
              : route.params.Athlete.birth_date.split("T")[0].split("-")[0]
          );
          setBirthMonth(
            route?.params?.event == "Official"
              ? route.params.Officials.birth_date.split("T")[0].split("-")[1]
              : route.params.Athlete.birth_date.split("T")[0].split("-")[1]
          );
          setBirthDate(
            route?.params?.event == "Official"
              ? route.params.Officials.birth_date.split("T")[0].split("-")[2]
              : route.params.Athlete.birth_date.split("T")[0].split("-")[2]
          );
          setBestValue(route.params.best_record);
        } catch (error) {
          console.log(error);
        }
      }
      if (route.params.type) {
        setValue(route.params.type);
      }
    }
  }, [focus]);

  const [modalVisible, setModalVisible] = useState(false);

  function onModalShow() {
    setModalVisible(true);
    setTimeout(() => {
      setModalVisible(false);
    }, 2000);
  }

  function newCondition() {
    if (route?.params?.event == "Official") {
      condition2();
    } else {
      // Submit();
      // new Date(route.params.limit_age_start).getTime()
      let nowDate = new Date(
        BirthYear + "-" + BirthMonth + "-" + BirthDate + "T00:00:00.000Z"
      ).getTime();
      let limit_age_start = new Date(route.params.limit_age_start).getTime();
      let limit_age_end = new Date(route.params.limit_age_end).getTime();
      // console.log(route.params.approbation_details);

      if (route.params.generation == "Senior") {
        condition();
      } else if (
        limit_age_start <= nowDate &&
        limit_age_end >= nowDate &&
        route.params.generation != "Senior"
      ) {
        condition();
      } else {
        setValidate("[Athletes] limit Age.");
        onModalShow();
        setDisable(false);
      }
    }
  }

  if (data == null) {
    return <View />;
  }

  return (
    <View
      style={width >= 1280 ? styles.viewDetail : stylesResponsive.viewDetail}
    >
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          // Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
          <View style={styles.viewModal}>
            <Text style={styles.textModal}>{validate}</Text>
          </View>
        </View>
      </Modal>
      <Text
        style={
          width >= 1280 ? styles.textSubject : stylesResponsive.textSubject
        }
      >
        IMAGE
      </Text>
      <TouchableOpacity onPress={pickImage} style={styles.buttonPickImg}>
        <View
          style={[
            styles.viewPickImg,
            { borderColor: "#ff0000", borderWidth: errored ? 1 : 0 },
          ]}
        >
          <Text style={styles.textUpPhoto}>Upload</Text>
        </View>
        <Text style={styles.textSelectPhoto}>select your photo*</Text>
      </TouchableOpacity>
      <Image
        resizeMode={"contain"}
        style={{
          width: width >= 1280 ? 300 : 120,
          height: width >= 1280 ? 100 : 80,
          borderRadius: 10,
          marginTop: 10,
        }}
        source={{ uri: image }}
      />
      <Text
        style={
          width >= 1280 ? styles.textSubject : stylesResponsive.textSubject
        }
      >
        FIRSTNAME*
      </Text>
      <TextInput
        defaultValue={state.first_name}
        onChangeText={(text) =>
          setState((val) => ({ ...val, first_name: text }))
        }
        style={styles.inputName}
      />
      <Text
        style={
          width >= 1280 ? styles.textSubject : stylesResponsive.textSubject
        }
      >
        LASTNAME*
      </Text>
      <TextInput
        defaultValue={state.last_name}
        onChangeText={(text) =>
          setState((val) => ({ ...val, last_name: text }))
        }
        style={styles.inputName}
      />
      <View style={{ flexDirection: width >= 1280 ? "row" : "column" }}>
        <View style={{ width: width * 0.22 }}>
          <Text
            style={
              width >= 1280 ? styles.textSubject : stylesResponsive.textSubject
            }
          >
            BIRTH
          </Text>
          <TouchableOpacity
            onPress={() => {
              setShowCalendarBirth(true);
            }}
            style={styles.viewBirth}
          >
            <Text style={styles.textDate}>
              {BirthYear + "-" + BirthMonth + "-" + BirthDate}
            </Text>
            <View style={styles.buttonSelectDate}>
              <Image
                resizeMode={"contain"}
                style={styles.imgCalendar}
                source={require("../img/sc Blue.png")}
              />
            </View>
          </TouchableOpacity>
          <CalendarPicker
            locale="en-us"
            show={showCalendarBirth}
            allowPageClickToClose={true}
            onClose={() => setShowCalendarBirth(false)}
            defaultDate={BirthYear + "-" + BirthMonth + "-" + BirthDate}
            onDatePicked={(res) => {
              setBirthYear(res.year);
              setBirthMonth(res.month);
              setBirthDate(res.date);
              setState((val) => ({
                ...val,
                birth_date:
                  res.year +
                  "-" +
                  res.month +
                  "-" +
                  res.date +
                  "T00:00:00.000Z",
              }));
            }}
          />
        </View>
        <View>
          <Text
            style={[
              width >= 1280 ? styles.textSubject : stylesResponsive.textSubject,
            ]}
          >
            GENDER
          </Text>
          <Text
            style={
              width >= 1280 ? styles.textSubject : stylesResponsive.textSubject
            }
          >
            {route.params.gender}
          </Text>
        </View>
        <View style={{ marginHorizontal: width >= 1280 && width * 0.065 }}>
          <Text
            style={
              width >= 1280 ? styles.textSubject : stylesResponsive.textSubject
            }
          >
            PASSPORT
          </Text>
          <TextInput
            defaultValue={state.passport}
            onChangeText={(text) =>
              setState((val) => ({ ...val, passport: text }))
            }
            maxLength={9}
            style={styles.textPassport}
          />
        </View>
        {/* <View>
          <Text
            style={[
              width >= 1280 ? styles.textSubject : stylesResponsive.textSubject,
            ]}
          >
            TYPE
          </Text>
          <Dropdown
            value={value}
            setValue={(val) => {
              setValue(val);
              setBestValue([
                {
                  event: "",
                  personal_best_stat: "00:00:00",
                  personal_best_date: moment().format("YYYY-MM-DD"),
                  personal_best_venue: "",
                  season_best_stat: "00:00:00",
                  season_best_date: moment().format("YYYY-MM-DD"),
                  season_best_venue: "",
                },
              ]);
            }}
            Type
          />
        </View> */}
      </View>
      <FlatList
        data={
          route?.params?.event == "Official"
            ? []
            : BestValue.sort((a, b) => {
                if (a.event == route.params.event) {
                  return -1;
                } else if (b.event == route.params.event) {
                  return 1;
                } else {
                  return 0;
                }
              })
        }
        renderItem={({ item, index }) =>
          index == 0 && (
            <>
              <View
                style={{ width: width >= 1280 ? width * 0.1 : width * 0.8 }}
              >
                {/* {state.gender !== "Male" && value !== "Official" && (
                <Dropdown
                  result={result2}
                  value={item.event}
                  setValue={(e) => {
                    setBestValue((val) =>
                      val.map((items, indexs) => {
                        if (indexs == index) {
                          return { ...items, event: e };
                        } else {
                          return { ...items };
                        }
                      })
                    );
                  }}
                  Event
                />
              )} */}
              </View>

              <Text
                style={[
                  width >= 1280
                    ? styles.textSubject
                    : stylesResponsive.textSubject,
                  {
                    color:
                      route?.params?.event == "Official"
                        ? "#B9B9B9"
                        : "#2B6AB1",
                  },
                ]}
              >
                PERSONAL BEST<Text style={{ fontSize: 14 }}>(if have)</Text>
              </Text>
              <View style={{ flexDirection: width >= 1280 ? "row" : "column" }}>
                <View
                  style={{
                    width: width >= 1280 ? width * 0.13 : width * 0.8,
                  }}
                >
                  <Text
                    style={[
                      styles.textSubjectEvent,
                      {
                        color:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    STATISTIC
                  </Text>
                  {route?.params?.event == "Official" ? (
                    <View style={{ flexDirection: "row" }}>
                      <View style={styles.statisticDisable} />
                      <Text style={styles.textStatisticDisable}>:</Text>
                      <View style={styles.statisticDisable} />
                      <Text style={styles.textStatisticDisable}>:</Text>
                      <View style={styles.statisticDisable} />
                    </View>
                  ) : (
                    <View style={{ flexDirection: "row" }}>
                      <TextInput
                        defaultValue={item.personal_best_stat.split(":")[0]}
                        onChangeText={(text) => {
                          let Arr = BestValue.filter((e, i) => i != index);
                          setBestValue((val) =>
                            Arr.concat({
                              ...item,
                              personal_best_stat:
                                hour(text) +
                                ":" +
                                item.personal_best_stat.split(":")[1] +
                                ":" +
                                item.personal_best_stat.split(":")[2],
                            })
                          );
                        }}
                        disableFullscreenUI
                        maxLength={2}
                        style={styles.statistic}
                      />
                      <Text style={styles.textStatistic}>:</Text>
                      <TextInput
                        value={item.personal_best_stat.split(":")[1]}
                        onChangeText={(text) => {
                          let Arr = BestValue.filter((e, i) => i != index);
                          setBestValue((val) =>
                            Arr.concat({
                              ...item,
                              personal_best_stat:
                                item.personal_best_stat.split(":")[0] +
                                ":" +
                                minute(text) +
                                ":" +
                                item.personal_best_stat.split(":")[2],
                            })
                          );
                        }}
                        maxLength={2}
                        style={styles.statistic}
                      />
                      <Text style={styles.textStatistic}>:</Text>
                      <TextInput
                        defaultValue={item.personal_best_stat.split(":")[2]}
                        onChangeText={(text) => {
                          let Arr = BestValue.filter((e, i) => i != index);
                          setBestValue((val) =>
                            Arr.concat({
                              ...item,
                              personal_best_stat:
                                item.personal_best_stat.split(":")[0] +
                                ":" +
                                item.personal_best_stat.split(":")[1] +
                                ":" +
                                minute(text),
                            })
                          );
                        }}
                        maxLength={2}
                        style={styles.statistic}
                      />
                    </View>
                  )}
                </View>
                <View
                  style={{
                    width: width >= 1280 ? width * 0.22 : width * 0.8,
                  }}
                >
                  <Text
                    style={[
                      styles.textSubjectEvent,
                      {
                        color:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    DATE
                  </Text>
                  <TouchableOpacity
                    disabled={route?.params?.event == "Official" ? true : false}
                    onPress={() => {
                      setShowCalendarPersonal(index);
                      setShowCalendarSeason(null);
                    }}
                    style={[
                      styles.viewBirth,
                      {
                        marginTop: 0,
                        borderColor:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    <Text style={styles.textDate}>
                      {route?.params?.event == "Official"
                        ? ""
                        : item.personal_best_date}
                    </Text>
                    <View
                      style={[
                        styles.buttonSelectDate,
                        {
                          borderLeftColor:
                            route?.params?.event == "Official"
                              ? "#B9B9B9"
                              : "#2B6AB1",
                        },
                      ]}
                    >
                      <Image
                        resizeMode={"contain"}
                        style={styles.imgCalendar}
                        source={
                          route?.params?.event == "Official"
                            ? require("../img/1.png")
                            : require("../img/sc Blue.png")
                        }
                      />
                    </View>
                  </TouchableOpacity>
                  <View>
                    <CalendarPicker
                      locale="en-us"
                      show={showCalendarPersonal == index}
                      defaultDate={item.personal_best_date}
                      onDatePicked={(res) => {
                        console.log("select");
                        setBestValue((Arr) =>
                          Arr.map((value, num) => {
                            if (num == index) {
                              return {
                                ...value,
                                personal_best_date:
                                  res.year +
                                  "-" +
                                  limit(res.month) +
                                  "-" +
                                  limit(res.date),
                              };
                            } else {
                              return value;
                            }
                          })
                        );
                      }}
                    />
                  </View>
                </View>
                <View>
                  <Text
                    style={[
                      styles.textSubjectEvent,
                      {
                        color:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    VENUE
                  </Text>
                  {route?.params?.event == "Official" ? (
                    <View style={styles.viewVenue}>
                      <FontAwesome
                        name="caret-down"
                        size={24}
                        color="#B9B9B9"
                        style={styles.iconDropdown}
                      />
                    </View>
                  ) : (
                    data != null && (
                      <Dropdown
                        value={item.personal_best_venue}
                        data={data}
                        setValue={(e) => {
                          // let Arr = BestValue.filter((e, i) => i != index);
                          setBestValue((val) =>
                            val.map((iten, i) => {
                              if (i == index) {
                                return { ...iten, personal_best_venue: e };
                              } else {
                                return iten;
                              }
                            })
                          );
                        }}
                        Venue
                      />
                    )
                  )}
                </View>
              </View>
              <Text
                style={[
                  width >= 1280
                    ? styles.textSubject
                    : stylesResponsive.textSubject,
                  {
                    marginTop: 30,
                    color:
                      route?.params?.event == "Official"
                        ? "#B9B9B9"
                        : "#2B6AB1",
                  },
                ]}
              >
                SEASON BEST<Text style={{ fontSize: 14 }}>(if have)</Text>
              </Text>
              <View style={{ flexDirection: width >= 1280 ? "row" : "column" }}>
                <View
                  style={{ width: width >= 1280 ? width * 0.13 : width * 0.8 }}
                >
                  <Text
                    style={[
                      styles.textSubjectEvent,
                      {
                        color:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    STATISTIC
                  </Text>
                  {route?.params?.event == "Official" ? (
                    <View style={{ flexDirection: "row" }}>
                      <View style={styles.statisticDisable} />
                      <Text style={styles.textStatisticDisable}>:</Text>
                      <View style={styles.statisticDisable} />
                      <Text style={styles.textStatisticDisable}>:</Text>
                      <View style={styles.statisticDisable} />
                    </View>
                  ) : (
                    <View style={{ flexDirection: "row" }}>
                      <TextInput
                        defaultValue={item.season_best_stat.split(":")[0]}
                        onChangeText={(text) => {
                          let Arr = BestValue.filter((e, i) => i != index);
                          setBestValue((val) =>
                            Arr.concat({
                              ...item,
                              season_best_stat:
                                hour(text) +
                                ":" +
                                item.season_best_stat.split(":")[1] +
                                ":" +
                                item.season_best_stat.split(":")[2],
                            })
                          );
                        }}
                        disableFullscreenUI
                        maxLength={2}
                        style={styles.statistic}
                      />
                      <Text style={styles.textStatistic}>:</Text>
                      <TextInput
                        defaultValue={item.season_best_stat.split(":")[1]}
                        onChangeText={(text) => {
                          let Arr = BestValue.filter((e, i) => i != index);
                          setBestValue((val) =>
                            Arr.concat({
                              ...item,
                              season_best_stat:
                                item.season_best_stat.split(":")[0] +
                                ":" +
                                minute(text) +
                                ":" +
                                item.season_best_stat.split(":")[2],
                            })
                          );
                        }}
                        maxLength={2}
                        style={styles.statistic}
                      />
                      <Text style={styles.textStatistic}>:</Text>
                      <TextInput
                        defaultValue={item.season_best_stat.split(":")[2]}
                        onChangeText={(text) => {
                          let Arr = BestValue.filter((e, i) => i != index);
                          setBestValue((val) =>
                            Arr.concat({
                              ...item,
                              season_best_stat:
                                item.season_best_stat.split(":")[0] +
                                ":" +
                                item.season_best_stat.split(":")[1] +
                                ":" +
                                minute(text),
                            })
                          );
                        }}
                        maxLength={2}
                        style={styles.statistic}
                      />
                    </View>
                  )}
                </View>
                <View style={{ width: width * 0.22 }}>
                  <Text
                    style={[
                      styles.textSubjectEvent,
                      {
                        color:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    DATE
                  </Text>
                  <TouchableOpacity
                    disabled={route?.params?.event == "Official" ? true : false}
                    onPress={() => {
                      setShowCalendarPersonal(null);
                      setShowCalendarSeason(index);
                    }}
                    style={[
                      styles.viewBirth,
                      {
                        marginTop: 0,
                        borderColor:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    <Text style={styles.textDate}>
                      {route?.params?.event == "Official"
                        ? ""
                        : item.season_best_date}
                    </Text>
                    <View
                      style={[
                        styles.buttonSelectDate,
                        {
                          borderLeftColor:
                            route?.params?.event == "Official"
                              ? "#B9B9B9"
                              : "#2B6AB1",
                        },
                      ]}
                    >
                      <Image
                        resizeMode={"contain"}
                        style={styles.imgCalendar}
                        source={
                          route?.params?.event == "Official"
                            ? require("../img/1.png")
                            : require("../img/sc Blue.png")
                        }
                      />
                    </View>
                  </TouchableOpacity>
                  <CalendarPicker
                    locale="en-us"
                    show={showCalendarSeason == index}
                    allowPageClickToClose={true}
                    // onClose={() => {
                    //   setShowCalendarPersonal(null);
                    //   setShowCalendarSeason(null);
                    // }}
                    defaultDate={item.season_best_date}
                    onDatePicked={(res) => {
                      setBestValue((Arr) =>
                        Arr.map((value, num) => {
                          if (num == index) {
                            return {
                              ...value,
                              season_best_date:
                                res.year +
                                "-" +
                                limit(res.month) +
                                "-" +
                                limit(res.date),
                            };
                          } else {
                            return value;
                          }
                        })
                      );
                    }}
                  />
                </View>
                <View>
                  <Text
                    style={[
                      styles.textSubjectEvent,
                      {
                        color:
                          route?.params?.event == "Official"
                            ? "#B9B9B9"
                            : "#2B6AB1",
                      },
                    ]}
                  >
                    VENUE
                  </Text>
                  {route?.params?.event == "Official" ? (
                    <View style={styles.viewVenue}>
                      <FontAwesome
                        name="caret-down"
                        size={24}
                        color="#B9B9B9"
                        style={styles.iconDropdown}
                      />
                    </View>
                  ) : (
                    data != null && (
                      <Dropdown
                        value={item.season_best_venue}
                        data={data}
                        setValue={(e) => {
                          setBestValue((val) =>
                            val.map((iten, i) => {
                              if (i == index) {
                                return { ...iten, season_best_venue: e };
                              } else {
                                return iten;
                              }
                            })
                          );
                        }}
                        Venue
                      />
                    )
                  )}
                </View>
              </View>
            </>
          )
        }
        extraData={[state, showCalendarPersonal, showCalendarSeason]}
      />

      <TouchableOpacity
        disabled={disable}
        onPress={() => {
          if (image) {
            seterrored(false);
            setDisable((val) => !val);
            if (route?.params?.event == "Official") {
              SubmitOfficial();
            } else {
              // Submit();
              // new Date(route.params.limit_age_start).getTime()
              let nowDate = new Date(
                BirthYear +
                  "-" +
                  BirthMonth +
                  "-" +
                  BirthDate +
                  "T00:00:00.000Z"
              ).getTime();
              let limit_age_start = new Date(
                route.params.limit_age_start
              ).getTime();
              let limit_age_end = new Date(
                route.params.limit_age_end
              ).getTime();
              // console.log(route.params.approbation_details);

              if (route.params.generation == "Senior") {
                Submit();
              } else if (
                limit_age_start <= nowDate &&
                limit_age_end >= nowDate &&
                route.params.generation != "Senior"
              ) {
                Submit();
              } else {
                setValidate("[Athletes] limit Age.");
                onModalShow();
                setDisable(false);
              }
            }
          } else {
            seterrored(true);
          }
        }}
        style={[
          width >= 1280 ? styles.buttonSave : stylesResponsive.buttonSave,
          { marginTop: 50 },
        ]}
      >
        <Text
          style={width >= 1280 ? styles.textSave : stylesResponsive.textSave}
        >
          SAVE
        </Text>
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({
  viewModal: {
    width: width * 0.4,
    height: 200,
    backgroundColor: "#FFBEBE",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 40,
    borderRadius: 38,
  },
  textModal: {
    fontSize: 22,
    fontFamily: "Prompt",
    alignSelf: "center",
    color: "#FF4646",
    textAlign: "center",
  },
  viewDetail: {
    width: width * 0.75,
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    marginVertical: 36,
    borderRadius: 46,
    paddingHorizontal: 45,
    paddingTop: 39,
    paddingBottom: height * 0.05,
  },
  textSubject: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 19,
  },
  buttonPickImg: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 7,
  },
  viewPickImg: {
    width: 110,
    height: 50,
    borderRadius: 9,
    backgroundColor: "#E6E6E6",
    justifyContent: "center",
  },
  textUpPhoto: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#959595",
    alignSelf: "center",
  },
  textSelectPhoto: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#959595",
    marginLeft: 8,
  },
  statistic: {
    width: 33,
    height: 29,
    borderRadius: 5,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#707070",
    paddingHorizontal: 7,
    color: "#2B6AB1",
    fontFamily: "Prompt",
  },
  textStatistic: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginHorizontal: 5,
  },
  statisticDisable: {
    width: 33,
    height: 29,
    borderRadius: 5,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#B9B9B9",
    paddingHorizontal: 7,
    color: "#B9B9B9",
    fontFamily: "Prompt",
  },
  textStatisticDisable: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#B9B9B9",
    marginHorizontal: 5,
  },
  textSubjectEvent: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginVertical: 13,
  },
  viewBirth: {
    width: 144,
    height: 29,
    borderWidth: 1,
    borderColor: "#2B6AB1",
    backgroundColor: "#FFFFFF",
    borderRadius: 6,
    marginTop: 18,
    justifyContent: "center",
  },
  buttonSelectDate: {
    width: 30,
    height: 29,
    borderLeftWidth: 1,
    borderLeftColor: "#2B6AB1",
    alignSelf: "flex-end",
    justifyContent: "center",
    position: "absolute",
  },
  textPassport: {
    width: 182,
    height: 29,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#2B6AB1",
    borderRadius: 6,
    paddingHorizontal: 10,
    marginTop: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  imgCalendar: {
    width: 15,
    height: 17,
    alignSelf: "center",
  },
  buttonAddMoreEvent: {
    width: width * 0.1,
    height: 40,
    backgroundColor: "#CCE4FF",
    borderRadius: 10,
    justifyContent: "center",
    marginVertical: 34,
  },
  textAddMoreEvent: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  buttonSave: {
    width: width * 0.05,
    height: 40,
    backgroundColor: "#2B6AB1",
    borderRadius: 10,
    justifyContent: "center",
  },
  textSave: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  textDate: {
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    paddingHorizontal: 10,
  },
  inputName: {
    height: 40,
    borderBottomWidth: 1,
    borderBottomColor: "#2B6AB1",
    paddingHorizontal: 10,
  },
  dropdownEvent: {
    width: width * 0.1,
    height: 29,
    borderWidth: 1,
    borderColor: "#B9B9B9",
    borderRadius: 6,
    marginTop: 18,
    justifyContent: "center",
    alignItems: "center",
  },
  iconDropdown: {
    position: "absolute",
    alignSelf: "flex-end",
    textAlign: "center",
    borderLeftWidth: 1,
    borderLeftColor: "#B9B9B9",
    width: 30,
  },
  viewVenue: {
    width: 144,
    height: 29,
    borderWidth: 1,
    borderColor: "#B9B9B9",
    borderRadius: 6,
    justifyContent: "center",
    alignItems: "center",
  },
});
const stylesResponsive = StyleSheet.create({
  viewDetail: {
    width: width * 0.9,
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    marginVertical: 20,
    borderRadius: 46,
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 20,
  },
  textSubject: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 19,
  },
  buttonPickImg: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 7,
  },
  viewPickImg: {
    width: 110,
    height: 50,
    borderRadius: 9,
    backgroundColor: "#E6E6E6",
    justifyContent: "center",
  },
  textUpPhoto: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#959595",
    alignSelf: "center",
  },
  textSelectPhoto: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#959595",
    marginLeft: 8,
  },
  buttonAddMoreEvent: {
    width: width * 0.4,
    height: 40,
    backgroundColor: "#CCE4FF",
    borderRadius: 10,
    justifyContent: "center",
    marginVertical: 20,
  },
  textAddMoreEvent: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  buttonSave: {
    width: width * 0.3,
    height: 40,
    backgroundColor: "#2B6AB1",
    borderRadius: 10,
    justifyContent: "center",
  },
  textSave: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
});
